import { IonButton, IonCol, IonSlides, IonSlide, IonLabel } from "@ionic/react";
import React, { useEffect, useState } from "react";
import PageHeading from "../../CustomComponents/PageHeading";
import { PageHeaderWithLoc } from "../BookService/pageHeadWithLoc";
import * as constants from "../../../constants";
import { connect } from "react-redux";
import "../Workshop/selectWorkshop.scss";
import "../BookService/service_details.scss";
import { CommonPointsForEachService } from "../BodyPanel/commonPointsForEachService";
import {
	addItemToCart,
	getCartItemsList,
	saveServiceSearchData,
	updateUserSettings,
} from "../../../Store/Actions";
import { COLLECTIONS, updateDoc } from "../../../firebase";
import { ToastMessage } from "../../../utils/toastMessage";

const WorkShopDetails: React.FC = (props: any) => {
	const { state = {} } = props.location;
	const { workshopDetail = {} } = state;
	const [toast, setToast] = React.useState({
		showToast: false,
		toastMessage: "",
		severity: "",
	});
	const sliderRef = React.useRef<HTMLIonSlidesElement>(null);
	const imgArray = [
		{ img: "/images/select_workshop_large.svg", id: "1" },
		{ img: "/images/carService.svg", id: "2" },
	];
	const slideOpts = {
		loop: false,
		autoplay: false,
		spaceBetween: 15,
		scrollBar: false,
	};

	const addToCart = async (workshopId: string) => {
		try {
			const {
				addOn = [],
				pricing = {},
				service = {},
				serviceProviderWorkshopList = [],
			} = state;
			const { amount = "", currency = "", model = "" } = pricing;
			if (
				props.service_data.map((ele: any) => ele.serviceId).includes(service.serviceId)
			) {
				//alert(constants.SERVICE_ALREADY_ADDED)
				throw Error(constants.SERVICE_ALREADY_ADDED);
			}
			const payload = {
				//addOnsSelected: !!addOnSections ? addOn : [],
				addOnsSelected: !!addOn.length ? addOn : [],
				appliedPrice: {
					amount: amount,
					currency: currency,
					model: model,
				},
				damageTypeId: service.damageTypeId || "",
				partId: service.partId || "",
				partDisplayName: service.displayName || "",
				recommended: true,
				serviceId: service.serviceId,
				workshopId: workshopId,
			};
			const userDoc = {
				settings: { ...props.settings, workshopId: workshopId },
			};
			updateDoc(props.uid, userDoc, COLLECTIONS.USERS);

			// console.log("WID Check === 74 === ", payload);
			await props.addItemToCart(payload);
			await props.updateUserSettings(payload);
			await props.getCartItemsList();
			await props.saveServiceSearchData({});
			// console.log("Props data =====", props);

			localStorage.setItem("workshopId", workshopId);

			await props.history.push({
				pathname: "/portal/book_service",
				state: {
					workshopId: workshopId,
				},
			});
		} catch (e: any) {
			setToast({
				showToast: true,
				toastMessage: e.message,
				severity: "warning",
			});
		}
	};
	return (
		<>
			<IonCol className="middle_panle res_bg_color" size-md="6">
				<div className="sd_parent">
					{!!Object.keys(workshopDetail).length && (
						<>
							<div className="service_panel_header">
								<PageHeaderWithLoc {...props} />
							</div>

							<div className="sd_heading_web">
								<PageHeading
									mainHeader={workshopDetail.displayTitle}
									navigation={props}
									cssClass="service_detail_heading"
								/>
							</div>
							<div className="wd_main_container">
								<div>
									<div className="workshop-heading-div">
										<IonLabel className="workshop-heading" color="secondary">
											{workshopDetail.displayTitle}
										</IonLabel>
									</div>
									{!!workshopDetail.imageUrls.length && (
										<IonSlides
											pager={true}
											options={slideOpts}
											ref={sliderRef}
											className={"wd_slide"}
											key={workshopDetail.imageUrls.map((ele: any) => ele).join(",")}
										>
											{workshopDetail.imageUrls.map((ele: any, index: number) => (
												<IonSlide className="workshop-details-slides" key={index}>
													<img src={ele} className="wd_img" />
												</IonSlide>
											))}
										</IonSlides>
									)}
								</div>
								<CommonPointsForEachService
									service={workshopDetail}
									showArticle={false}
								/>
							</div>

							<div className="page-actions workshop_footer">
								<IonButton
									fill="outline"
									color="primary"
									className="page-action-buttons"
									onClick={() => addToCart(workshopDetail.workshopId)}
								>
									{constants.ADD_TO_CART}
								</IonButton>
								<IonButton
									fill="solid"
									className="page-action-buttons book_now_button"
									onClick={() => addToCart(workshopDetail.workshopId)}
								>
									{constants.BOOK_NOW}
								</IonButton>
							</div>
						</>
					)}
				</div>
				<ToastMessage
					showToast={toast.showToast}
					ToastMessage={toast.toastMessage}
					severity={toast.severity}
					onDidDismiss={() => {
						setToast({
							showToast: false,
							toastMessage: "",
							severity: "",
						});
					}}
				/>
			</IonCol>
		</>
	);
};
export default connect(
	({
		auth,
		cart: { service_data, cart_estimates },
		userInfo: { userVehiclesList, servicesDetails },
	}: any) => {
		return { ...auth, service_data, userVehiclesList, servicesDetails };
	},
	{ addItemToCart, getCartItemsList, saveServiceSearchData, updateUserSettings }
)(WorkShopDetails);
